// extracted by mini-css-extract-plugin
export default {"DLNumberInput":"src-js-components-DLNumberInput---DLNumberInput---SV+IH"};